<template>
    <div>
        <b-row>
            <b-col>
                <b-card>
                    <div slot="header">
                        <h4>{{$t('USER')}}</h4>
                    </div>
                    <b-tabs>
                        <b-tab>
                            <template slot="title">
                                <i class="fa fa-user-o fa-fw" aria-hidden="true"></i> {{$t('BASIC')}}
                            </template>
                            <br>
                            <user-basic-form></user-basic-form>
                        </b-tab>

                    </b-tabs>
                </b-card>
            </b-col>

        </b-row>
    </div>
</template>

<script>

import UserBasicForm from '../../components/user/UserBasicForm'
    export default {
        name: "User",
        components: {
          UserBasicForm,
        }
    }
</script>

<style scoped>

</style>
